import Header from 'components/Header/Header'
import cn from 'classnames'
import s from './Layout.module.scss'

interface Props {
  children: React.ReactNode
  className?: string
}
const defaultProps = {
  className: undefined,
}

const Layout = ({ children, className }: Props): JSX.Element => (
  <div className={s.layout}>
    <Header />
    <div className={cn(className)}>{children}</div>
  </div>
)
Layout.defaultProps = defaultProps
export default Layout
